// @ts-nocheck
// TODO: ported from yjs - will remove that code when
// https://github.com/yjs/yjs/pull/712 is merged
import * as error from "lib0/error"
import * as decoding from "lib0/decoding"
import * as map from "lib0/map"
import * as binary from "lib0/binary"
import * as Y from "yjs"
export const readYArray = (_decoder) => new Y.Array()
export const readYMap = (_decoder) => new Y.Map()
export const readYText = (_decoder) => new Y.Text()
export const readYXmlElement = (_decoder) => new Y.XmlElement()
export const readYXmlFragment = (_decoder) => new Y.XmlFragment()
export const readYXmlHook = (_decoder) => new Y.XmlHook(_decoder.readKey())
export const readYXmlText = (_decoder) => new Y.XmlText()

export const typeRefs = [
  readYArray,
  readYMap,
  readYText,
  readYXmlElement,
  readYXmlFragment,
  readYXmlHook,
  readYXmlText,
]

export const readContentDeleted = (decoder) => new Y.ContentDeleted(decoder.readLen())
export const readContentJSON = (decoder) => {
  const len = decoder.readLen()
  const cs = []
  for (let i = 0; i < len; i++) {
    const c = decoder.readString()
    if (c === "undefined") {
      cs.push(undefined)
    } else {
      cs.push(JSON.parse(c))
    }
  }
  return new Y.ContentJSON(cs)
}
const readContentBinary = (decoder) => new Y.ContentBinary(decoder.readBuf())
const readContentString = (decoder) => new Y.ContentString(decoder.readString())
const readContentEmbed = (decoder) => new Y.ContentEmbed(decoder.readJSON())
const readContentFormat = (decoder) => new Y.ContentFormat(decoder.readKey(), decoder.readJSON())
const readContentType = (decoder) => new Y.ContentType(typeRefs[decoder.readTypeRef()](decoder))
const readContentAny = (decoder) => {
  const len = decoder.readLen()
  const cs = []
  for (let i = 0; i < len; i++) {
    cs.push(decoder.readAny())
  }
  return new Y.ContentAny(cs)
}

export const contentRefs = [
  () => {
    error.unexpectedCase()
  }, // GC is not ItemContent
  readContentDeleted, // 1
  readContentJSON, // 2
  readContentBinary, // 3
  readContentString, // 4
  readContentEmbed, // 5
  readContentFormat, // 6
  readContentType, // 7
  readContentAny, // 8
  //readContentDoc, // 9 // ms: skipped document inside document
  () => {
    error.unexpectedCase()
  }, // 10 - Skip is not ItemContent
]

export class DeleteItem {
  /**
   * @param {number} clock
   * @param {number} len
   */
  readonly clock
  readonly len
  constructor(clock, len) {
    /**
     * @type {number}
     */
    this.clock = clock
    /**
     * @type {number}
     */
    this.len = len
  }
}
export class DeleteSet {
  readonly clients
  constructor() {
    /**
     * @type {Map<number,Array<DeleteItem>>}
     */
    this.clients = new Map()
  }
}
export const readDeleteSet = (decoder) => {
  const ds = new DeleteSet()
  const numClients = decoding.readVarUint(decoder.restDecoder)
  for (let i = 0; i < numClients; i++) {
    decoder.resetDsCurVal()
    const client = decoding.readVarUint(decoder.restDecoder)
    const numberOfDeletes = decoding.readVarUint(decoder.restDecoder)
    if (numberOfDeletes > 0) {
      const dsField = map.setIfUndefined(
        ds.clients,
        client,
        () => /** @type {Array<DeleteItem>} */ [],
      )
      for (let i = 0; i < numberOfDeletes; i++) {
        dsField.push(new DeleteItem(decoder.readDsClock(), decoder.readDsLen()))
      }
    }
  }
  return ds
}

const readItemContent = (decoder, info) => contentRefs[info & binary.BITS5](decoder)

/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */
function* lazyStructReaderGenerator(decoder) {
  const numOfStateUpdates = decoding.readVarUint(decoder.restDecoder)
  for (let i = 0; i < numOfStateUpdates; i++) {
    const numberOfStructs = decoding.readVarUint(decoder.restDecoder)
    const client = decoder.readClient()
    let clock = decoding.readVarUint(decoder.restDecoder)
    for (let i = 0; i < numberOfStructs; i++) {
      const info = decoder.readInfo()
      // @todo use switch instead of ifs
      if (info === 10) {
        const len = decoding.readVarUint(decoder.restDecoder)
        yield new Y.Skip(Y.createID(client, clock), len)
        clock += len
      } else if ((binary.BITS5 & info) !== 0) {
        const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
        // and we read the next string as parentYKey.
        // It indicates how we store/retrieve parent from `y.share`
        // @type {string|null}
        const struct = new Y.Item(
          Y.createID(client, clock),
          null, // left
          (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null, // origin
          null, // right
          (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null, // right origin
          // @ts-ignore Force writing a string here.
          cantCopyParentInfo
            ? decoder.readParentInfo()
              ? decoder.readString()
              : decoder.readLeftID()
            : null, // parent
          cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
          readItemContent(decoder, info), // item content
        )
        yield struct
        clock += struct.length
      } else {
        const len = decoder.readLen()
        yield new Y.GC(Y.createID(client, clock), len)
        clock += len
      }
    }
  }
}

export class LazyStructReader {
  /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */
  readonly gen
  readonly curr
  readonly done
  readonly filterSkips
  constructor(decoder, filterSkips) {
    this.gen = lazyStructReaderGenerator(decoder)
    /**
     * @type {null | Item | Skip | GC}
     */
    this.curr = null
    this.done = false
    this.filterSkips = filterSkips
    this.next()
  }

  /**
   * @return {Item | GC | Skip |null}
   */
  next() {
    // ignore "Skip" structs
    do {
      this.curr = this.gen.next().value || null
    } while (this.filterSkips && this.curr !== null && this.curr.constructor === Y.Skip)
    return this.curr
  }
}
